export const getIndexName = (locale: string) => {
  if (locale === 'fi') {
    return 'fi_hae';
  } else if (locale === 'sv') {
    return 'sv_sok';
  } else {
    return 'en_search';
  }
};

export const getQueryIndexName = (locale: string) => {
  if (locale === 'fi') {
    return 'fi_hae_query_suggestions';
  } else if (locale === 'sv') {
    return 'sv_sok_query_suggestions';
  } else {
    return 'en_search_query_suggestions';
  }
};

/** Jobs index replica sorted by posted date (newest first) — same as SRP “newest” sort. */
export function getJobsIndexNamePostedDateDesc(locale: string): string {
  return `${getIndexName(locale)}_postedDate_desc`;
}

/** Typesense job collection for a locale — mirrors web-app/types/typesense/search-locale.ts. */
export const getTypesenseCollectionName = (locale: string): string => {
  if (locale === 'fi') return 'jobs_fi';
  if (locale === 'sv') return 'jobs_sv';
  return 'jobs_en';
};
